const ContactReasons = {
    teacherTraining: "Teacher Training/Workshops",
    kinderBeatLicence: "Kinder Beat Licensing",
    encoreLicence: "Encore on Keys Licensing",
    musicLessons: "Music Lessons",
    encoreMusicWizApp: "Encore Music Wiz App",
    encoreStarCompetition: "Encore Star Competition",
    other: "Other"
}

Object.freeze(ContactReasons);

export default ContactReasons